import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AuthProvider } from "./authprovider"; // Adjust the import path as necessary

import Login from "./login.js";
import Adminpage from "./adminpage.js";
import Memberpage from "./memberpage.js";
import Register from "./register.js";
import Officer from "./officerpage.js";
import Visitorregistry from "./visitorregistry.js";
import Listuser from "./listuser.js";
import Listalluser from "./listalluser.js";
import Listvisitor from "./listvisitor.js";
import Myinfo from "./myinfo.js";
import RequestUpdatepage from "./requestUpdatepage.js";
import Viewrequest from "./viewrequest.js";
import Readrequest from "./readrequest.js";
import Setmeeting from "./setmeeting.js";
import Viewmeeting from "./viewmeeting.js";
import Newuser from "./newuser.js";
import Officerviewmeeting from "./officerviewmeeting.js";
import Memberviewmeeting from "./memberviewmeeting.js";
import Officersetmeeting from "./officersetmeeting.js";
import Addcases from "./addcase.js";
import Viewcases from "./viewcases.js";
import Header from "./header.js";
import Footer from "./footer.js";
import ProtectedRoute from "./protectedroute";

function App() {
  return (
    <AuthProvider>
      <Router>
        <HeaderFooterWrapper> 
          <Routes>
              <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route
              path="/adminpage"
              element={
                <ProtectedRoute>
                  <Adminpage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/viewrequest"
              element={
                <ProtectedRoute>
                  <Viewrequest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/readrequest/:brgyId"
              element={
                <ProtectedRoute>
                  <Readrequest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/memberpage/:brgyId"
              element={
                <ProtectedRoute>
                  <Memberpage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/myinfo/:brgyId"
              element={
                <ProtectedRoute>
                  <Myinfo />
                </ProtectedRoute>
              }
            />
            <Route
              path="/requestUpdatepage/:brgyId"
              element={
                <ProtectedRoute>
                  <RequestUpdatepage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/officerpage"
              element={
                <ProtectedRoute>
                  <Officer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/visitorregistry"
              element={
                <ProtectedRoute>
                  <Visitorregistry />
                </ProtectedRoute>
              }
            />
            <Route
              path="/listuser"
              element={
                <ProtectedRoute>
                  <Listuser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/listalluser"
              element={
                <ProtectedRoute>
                  <Listalluser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/listvisitor"
              element={
                <ProtectedRoute>
                  <Listvisitor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/setmeeting"
              element={
                <ProtectedRoute>
                  <Setmeeting />
                </ProtectedRoute>
              }
            />
            <Route
              path="/viewmeeting"
              element={
                <ProtectedRoute>
                  <Viewmeeting />
                </ProtectedRoute>
              }
            />
            <Route
              path="/newuser"
              element={
                <ProtectedRoute>
                  <Newuser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/officerviewmeeting"
              element={
                <ProtectedRoute>
                  <Officerviewmeeting />
                </ProtectedRoute>
              }
            />
            <Route
              path="/memberviewmeeting/:brgyId"
              element={
                <ProtectedRoute>
                  <Memberviewmeeting />
                </ProtectedRoute>
              }
            />
            <Route
              path="/officersetmeeting"
              element={
                <ProtectedRoute>
                  <Officersetmeeting />
                </ProtectedRoute>
              }
            />
            <Route
              path="/addcase"
              element={
                <ProtectedRoute>
                  <Addcases />
                </ProtectedRoute>
              }
            />
            <Route
              path="/viewcases"
              element={
                <ProtectedRoute>
                  <Viewcases />
                </ProtectedRoute>
              }
            />
          </Routes>
         </HeaderFooterWrapper> 
      </Router>
    </AuthProvider>
  );
}

const HeaderFooterWrapper = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
    const isLogPage = location.pathname === "/";

  return (
    <>
      {!isLoginPage && !isLogPage && <Header />}
      {children}
      {!isLoginPage && !isLogPage && <Footer />}
    </>
  );
};

export default App;
